import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { envs } from '../constants/envs.ts';

interface DecodeEmailOptOutResponse {
  email: string;
  hasConfirmedOptOut: boolean;
  type: string;
}

interface DecodeEmailParams {
  token: string;
}
interface EmailOptedOutResponse {
  createdTime: string;
  updatedTime: string;
  deleted: boolean;
  email: string;
  id: string;
  optOutType: string;
}

export const api = createApi({
  reducerPath: 'optOutApi',
  baseQuery: fetchBaseQuery({
    baseUrl: envs.BASE_URL.trim()
      ? new URL('/api', envs.BASE_URL).toString()
      : '/api',
    validateStatus: (response) => {
      return (
        (response.status >= 200 && response.status < 300) ||
        response.status === 409
      );
    },
  }),
  endpoints: (build) => {
    return {
      decodeEmailOptOut: build.query<
        DecodeEmailOptOutResponse,
        DecodeEmailParams
      >({
        query: (params) => {
          return {
            url: `email-opt-outs`,
            params,
          };
        },
      }),
      requestEmailOptOut: build.query<EmailOptedOutResponse, DecodeEmailParams>(
        {
          query: (params) => {
            return {
              url: 'email-opt-outs',
              params,
              method: 'POST',
            };
          },
        }
      ),
    };
  },
});
